import styled, { keyframes } from 'styled-components';
export default styled.div<{ isLose: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  display: ${({ isLose }) => isLose ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  color: #4198b9;
  box-shadow: inset 0 0 135px 10px #CB1212;
  z-index: 1;
  pointer-events:none;
  animation-name: ${fade => fade && fadeOut};
    animation-duration: .5s;
      animation-iteration-count: infinite;
`

const fadeOut = keyframes`
 0% {   opacity: 1; }
  50% {  opacity: 0; }
  100% {  opacity: 1; }
`
